import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Layout.module.css';

const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { 
    label: 'Our Offerings', 
    href: '#offerings',
    dropdown: [
      { 
        label: 'Our Product', 
        href: '#products',
        submenu: [
          { label: 'OpsAssist', href: '/ops-assist' } // Updated: Fixed Ops Assist to OpsAssist
        ]
      },
      { label: 'Case Studies', href: '/case-studies' }
    ]
  },
  { label: 'News & Insights', href: '/news-insights' },
  { label: 'About Us', href: '/about-us' },
  { label: 'Careers', href: '/careers' }
];

function Layout({ children }) {
  const location = useLocation();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);


  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
        setActiveSubmenu(null);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDropdownClick = (linkLabel) => {
    setActiveDropdown(activeDropdown === linkLabel ? null : linkLabel);
    setActiveSubmenu(null); // Close submenu when main dropdown changes
  };

  const handleSubmenuClick = (submenuLabel) => {
    setActiveSubmenu(activeSubmenu === submenuLabel ? null : submenuLabel);
  };


  return (
    <div>
      <nav className={styles.navbar}>
        <div className={styles.container}>
              <Link to="/" className={styles.brand} onClick={() => setMobileMenuOpen(false)}>
                <img 
                  src={process.env.PUBLIC_URL + '/images/neural-lab.png'} 
                  alt="Neural Lab" 
                  className={styles.logoImage}
                />
                <span className={styles.brandName}>Neural Lab</span>
              </Link>
          
          <button 
            className={styles.mobileMenuButton}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={styles.hamburger}>
              <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.active : ''}`} />
              <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.active : ''}`} />
              <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.active : ''}`} />
            </span>
          </button>
          
          <div className={`${styles.nav} ${mobileMenuOpen ? styles.navOpen : ''}`}>
            {NAV_LINKS.map(link => (
              <div 
                key={link.label}
                className={styles.navItem}
                ref={link.dropdown ? dropdownRef : null}
              >
                {link.dropdown ? (
                  <>
                    <span 
                      className={`${styles.navLink} ${location.pathname === link.href ? styles.active : ''}`}
                      onClick={() => handleDropdownClick(link.label)}
                    >
                      {link.label}  <span className={styles.dropdownArrow}>
                        {activeDropdown === link.label ? '▲' : '▼'}
                      </span>
                    </span>
                    {activeDropdown === link.label && (
                      <div className={styles.dropdown}>
                        {link.dropdown.map(dropdownLink => (
                          <div key={dropdownLink.label} className={styles.dropdownItem}>
                          {dropdownLink.submenu ? (
                            <>
                              <span 
                                className={styles.dropdownLink}
                                onClick={() => handleSubmenuClick(dropdownLink.label)}
                              >
                                {dropdownLink.label} 
                              </span>
                              {activeSubmenu === dropdownLink.label && (
                                <div className={styles.submenuInline}>
                                  {dropdownLink.submenu.map(submenuLink => (
                                    <Link 
                                      key={submenuLink.label}
                                      to={submenuLink.href}
                                      className={styles.submenuLink}
                                      onClick={() => {
                                        setActiveDropdown(null);
                                        setActiveSubmenu(null);
                                        setMobileMenuOpen(false);
                                      }}
                                    >
                                      {submenuLink.label}
                                    </Link>
                                  ))}
                                </div>
                              )}
                            </>
                          ) : (

                              <Link 
                                to={dropdownLink.href}
                                className={styles.dropdownLink}
                                onClick={() => {
                                  setActiveDropdown(null);
                                  setMobileMenuOpen(false);
                                }}
                              >
                                {dropdownLink.label}
                              </Link>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link 
                    to={link.href}
                    className={`${styles.navLink} ${location.pathname === link.href ? styles.active : ''}`}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.label}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </nav>
      <main>{children}</main>
    </div>
  );
}

export default Layout;
